<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Notifications'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

      @if (loaded) {
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Add notifications to your account:'" />
        </tidy-row>
        <tidy-card>
          @if (isAccountAdmin && hasTeams) {
            <tidy-row>
              <tidy-text
                [header]="'Group to Notify'" />
            </tidy-row>
            <tidy-row class="field-bottom-padding">
              <tidy-select
                [icon]="'assets/svg/notifications.svg'"
                [label]="'What group do you want to notify?'"
                formControlName="team"
                [form]="form.controls.team"
                [items]="teamItems" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-text
              [header]="'Notification Channel'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'Where should we send these notifications?'" />
          </tidy-row>
          <tidy-row class="field-bottom-padding">
            <tidy-radio-button
              formControlName="channel"
              [form]="form.controls.channel"
              [items]="channelItems" />
          </tidy-row>
          @if (form.value.channel) {
            <tidy-row>
              <tidy-text
                [header]="getWebhookUrlLabel()" />
            </tidy-row>
            <tidy-row>
              @if (form.value.channel === 'slack') {
                <tidy-text
                  [body]="'Add a Slack webhook to get notified on Slack.'" />
              }
              @if (form.value.channel === 'webhook') {
                <tidy-text
                  [body]="'Add a webhook to get notified in your application.'" />
              }
              <tidy-text
                [body]="'Learn More'"
                class="link"
                (action)="goToLearnMoreNotifications()" />
            </tidy-row>
            <tidy-row class="field-bottom-padding field-top-padding">
              <tidy-input
                formControlName="webhookUrl"
                [label]="'Endpoint URL'"
                [form]="form.controls.webhookUrl"
                [icon]="'assets/svg/globe.svg'"
                [errorMessage]="'Please input a URL.'"
                [submitted]="submitted" />
            </tidy-row>
          }
          <tidy-row>
            <tidy-text
              [header]="'Notification Events'" />
          </tidy-row>
          <tidy-row>
            <tidy-text
              [body]="'What events should trigger notifications?'" />
          </tidy-row>
          @for (event of eventItems; track event) {
            <tidy-checkbox
              [(checked)]="event.checked"
              [items]="[{value: event.value, viewValue: (event.viewValue | translate)}]" />
          }
          @if (showSelectedEventsError) {
            <tidy-error-message
              [text]="'Please select at least one event.'" />
          }
        </tidy-card>
        @if (errorMessage) {
          <tidy-error-message
            [text]="errorMessage" />
        }
        <tidy-button
          [text]="'Add Account Notification'"
          [action]="boundAddWebhook"
          class="primary" />
      }
    </tidy-wrapper>
  </form>
</ng-template>


@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}

